/**
 * Externded trim function
 *
 * Removes any whitespace character, UTF-8 byte order mark (BOM) and non-breaking space in Latin1 (ISO 8859-1)
 * @export
 * @param {string} str
 * @return {*}  {string}
 */
export function srpTrim(str: string): string {
    if (str == null) {
        return '';
    }
    const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    return str.replace(rtrim, '');
}